var _style, _circle, _circle2, _ellipse, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpolloLogo = function SvgOpolloLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "opollo_logo_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1280 800",
    style: {
      enableBackground: "new 0 0 1280 800"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".opollo_logo_svg__st1{fill:#6cf}")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "opollo_logo_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.324,
    y1: 316.523,
    x2: 495.824,
    y2: 316.523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6cf",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    style: {
      stopColor: "#6cf",
      stopOpacity: 0.064
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6cf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 324.57,
    cy: 316.52,
    r: 171.25,
    style: {
      fill: "url(#opollo_logo_svg__SVGID_1_)"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "opollo_logo_svg__st1",
    cx: 741.5,
    cy: 399.5,
    r: 85.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "opollo_logo_svg__st1",
    cx: 1090.5,
    cy: 399.5,
    r: 85.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "opollo_logo_svg__st1",
    cx: 571.19,
    cy: 399,
    rx: 82.81,
    ry: 85.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "opollo_logo_svg__st1",
    d: "m509.71 613.42-79.42-.36 71.83-299.03 76.59.16zM889.9 484.5l-77.01-.57 79.76-297.63 74.25.37zM973.65 484.5l-77-.57L976.4 186.3l74.26.37z"
  })));
};

export default SvgOpolloLogo;